import { MessageCircle, Instagram, MapPin, Truck } from "lucide-react";
import Logo from "./Logo";
import { FlameDivider } from "./motifs";
import { Reveal } from "./Reveal";
import { WA_DEFAULT, WHATSAPP_NUMBER, INSTAGRAM_URL, INSTAGRAM_HANDLE, scrollToId } from "@/lib/site";

const Footer = () => (
    <footer id="contact" data-testid="footer-section" className="relative bg-[#472500] text-[#F0EEE8] overflow-hidden">
        <div
            className="absolute inset-0 opacity-[0.05] pointer-events-none"
            style={{ backgroundImage: "radial-gradient(#E2BA03 1px, transparent 1px)", backgroundSize: "30px 30px" }}
            aria-hidden="true"
        />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-24 sm:pt-32 pb-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
                <Reveal>
                    <div>
                        <button
                            onClick={() => scrollToId("#top")}
                            className="flex items-center gap-4 group"
                            data-testid="footer-home-link"
                            aria-label="Back to top"
                        >
                            <Logo size={72} className="transition-transform duration-500 group-hover:rotate-[8deg]" />
                            <span className="font-script text-4xl text-[#F0EEE8]">festive theory</span>
                        </button>
                        <p className="mt-8 font-display italic text-2xl sm:text-3xl text-[#E2BA03] leading-snug max-w-md">
                            Traditional Indian charm for modern homes.
                        </p>
                        <p className="mt-4 text-base text-[#F0EEE8]/60 max-w-md leading-relaxed">
                            Handmade. Heartmade. Festive décor, pooja essentials and gifting — every
                            celebration, styled just right.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.12}>
                    <div className="flex flex-col gap-5 lg:pt-4">
                        <p className="text-xs uppercase tracking-[0.3em] text-[#F0EEE8]/50 font-semibold">
                            Order via a message
                        </p>
                        <a
                            href={WA_DEFAULT}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp-link"
                            className="group flex items-center justify-between rounded-2xl border border-[#F0EEE8]/20 px-6 py-5 transition-all duration-300 hover:border-[#E2BA03] hover:bg-[#E2BA03]/10"
                        >
                            <span className="flex items-center gap-4">
                                <MessageCircle size={22} className="text-[#E2BA03]" />
                                <span>
                                    <span className="block font-semibold">WhatsApp</span>
                                    <span className="block text-sm text-[#F0EEE8]/60">{WHATSAPP_NUMBER}</span>
                                </span>
                            </span>
                            <span className="text-xs uppercase tracking-[0.2em] text-[#F0EEE8]/50 group-hover:text-[#E2BA03] transition-colors">
                                Chat now
                            </span>
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram-link"
                            className="group flex items-center justify-between rounded-2xl border border-[#F0EEE8]/20 px-6 py-5 transition-all duration-300 hover:border-[#E2BA03] hover:bg-[#E2BA03]/10"
                        >
                            <span className="flex items-center gap-4">
                                <Instagram size={22} className="text-[#E2BA03]" />
                                <span>
                                    <span className="block font-semibold">Instagram</span>
                                    <span className="block text-sm text-[#F0EEE8]/60">{INSTAGRAM_HANDLE}</span>
                                </span>
                            </span>
                            <span className="text-xs uppercase tracking-[0.2em] text-[#F0EEE8]/50 group-hover:text-[#E2BA03] transition-colors">
                                DM us
                            </span>
                        </a>
                        <div className="flex flex-col gap-3 mt-2 text-sm text-[#F0EEE8]/65" data-testid="footer-location">
                            <span className="flex items-center gap-3">
                                <MapPin size={16} className="text-[#E2BA03] shrink-0" />
                                Pickup available in Point Cook, VIC
                            </span>
                            <span className="flex items-center gap-3">
                                <Truck size={16} className="text-[#E2BA03] shrink-0" />
                                Delivering Australia-wide
                            </span>
                        </div>
                    </div>
                </Reveal>
            </div>
            <div className="mt-20 text-[#E2BA03]/70">
                <FlameDivider />
            </div>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#F0EEE8]/45 tracking-wide">
                <p>© 2026 Festive Theory · Point Cook, Victoria</p>
                <p className="font-script text-lg text-[#F0EEE8]/55">Handmade. Heartmade.</p>
            </div>
        </div>
    </footer>
);

export default Footer;
